import { createReducer, createActions } from 'reduxsauce'
import {
  failureFeedback,
  initialFeedback,
  requestFeedback,
  successFeedback
} from './utils'

const INITIAL_STATE = {
  feedback: initialFeedback(),
  acceptanceFeedback: initialFeedback(),
  consentType: null, // 'ACCEPTANCE' | 'SIGNATURE'
  documentUrl: null,
  shouldShowModal: false,
  acceptanceLoading: false,
  acceptanceError: null,
}

const { Types, Creators } = createActions(
  {
    checkConsentType: [],
    checkConsentTypeSuccess: ['data'],
    checkConsentTypeFailure: ['errors'],
    acceptNetworkContract: [],
    acceptNetworkContractSuccess: ['data'],
    acceptNetworkContractFailure: ['errors'],
    checkAddNewChildPermission: [],
    closeNetworkModal: [],
    setShowNetworkModal: ['shouldShow'],
    clear: [],
  },
  { prefix: 'NETWORK_CONTRACT_' }
)

// Check consent type actions
const checkConsentType = (state) => ({
  ...state,
  feedback: requestFeedback(),
  consentType: null,
  documentUrl: null,
})

const checkConsentTypeSuccess = (state, { data }) => ({
  ...state,
  feedback: successFeedback(),
  consentType: data.consentType,
  documentUrl: data.documentUrl || null,
})

const checkConsentTypeFailure = (state, { errors }) => ({
  ...state,
  feedback: failureFeedback(errors),
  consentType: null,
  documentUrl: null,
})

// Accept contract actions
const acceptNetworkContract = (state) => ({
  ...state,
  acceptanceFeedback: requestFeedback(),
  acceptanceLoading: true,
  acceptanceError: null,
})

const acceptNetworkContractSuccess = (state) => ({
  ...state,
  acceptanceFeedback: successFeedback(),
  acceptanceLoading: false,
  acceptanceError: null,
  shouldShowModal: false, // Hide modal on successful acceptance
})

const acceptNetworkContractFailure = (state, { errors }) => ({
  ...state,
  acceptanceFeedback: failureFeedback(errors),
  acceptanceLoading: false,
  acceptanceError: errors,
})

// Modal visibility actions
const closeNetworkModal = (state) => ({
  ...state,
  shouldShowModal: false,
})

const setShowNetworkModal = (state, { shouldShow }) => ({
  ...state,
  shouldShowModal: shouldShow,
})

const clear = () => INITIAL_STATE

export const NetworkContractActionTypes = Types

const HANDLERS = {
  [Types.CHECK_CONSENT_TYPE]: checkConsentType,
  [Types.CHECK_CONSENT_TYPE_SUCCESS]: checkConsentTypeSuccess,
  [Types.CHECK_CONSENT_TYPE_FAILURE]: checkConsentTypeFailure,
  [Types.ACCEPT_NETWORK_CONTRACT]: acceptNetworkContract,
  [Types.ACCEPT_NETWORK_CONTRACT_SUCCESS]: acceptNetworkContractSuccess,
  [Types.ACCEPT_NETWORK_CONTRACT_FAILURE]: acceptNetworkContractFailure,
  [Types.CLOSE_NETWORK_MODAL]: closeNetworkModal,
  [Types.SET_SHOW_NETWORK_MODAL]: setShowNetworkModal,
  [Types.CLEAR]: clear,
}

export const NetworkContractActionCreators = Creators

export default createReducer(INITIAL_STATE, HANDLERS)
